import { SidebarDelimiter } from "@endya-conformite/ui-kit";
import ChevronLeft from "@endya-conformite/ui-kit/src/assets/icons/chevron-left.svg?react";
import ChevronRight from "@endya-conformite/ui-kit/src/assets/icons/chevron-right.svg?react";
import { SidebarDroiteProps } from "@src/components/sidebar/sidebar.types";
import { PersonnesAVerifier } from "@src/components/sidebar/SidebarDroite/PersonnesAVerifier";
import { axeTypeToLabel } from "@src/pages/controle-quinquennal/controleQuinquennal.helper";
import classNames from "classnames";
import { DocumentsAssocies } from "./DocumentsAssocies";
import styles from "./SidebarDroite.module.scss";

export function SidebarDroite({
  idCq,
  idAxe,
  idEntreprise,
  millesime,
  siren,
  axeName,
  onPersonneSelected,
  selectedPersonneId,
  collapsed,
  onToggle,
  isReadOnly,
}: SidebarDroiteProps & { selectedPersonneId?: string }) {
  const isAssujetti = axeName === axeTypeToLabel.ASSUJETTI;

  return (
    <div className={styles.sidebarWrapper}>
      <button
        type="button"
        className={styles.toggleButton}
        onClick={onToggle}
        aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        {collapsed ? <ChevronLeft /> : <ChevronRight />}
      </button>
      <div
        className={classNames(styles.sidebar, {
          [styles.collapsed]: collapsed,
        })}
      >
        {!collapsed && (
          <>
            {isAssujetti && (
              <>
                <PersonnesAVerifier
                  idCq={idCq}
                  idAxe={idAxe}
                  idEntreprise={idEntreprise}
                  siren={siren}
                  millesime={millesime}
                  onPersonneSelected={onPersonneSelected}
                  selectedPersonneId={selectedPersonneId}
                />
                <SidebarDelimiter />
              </>
            )}
            <DocumentsAssocies
              idCq={idCq}
              idAxe={idAxe}
              idEntreprise={idEntreprise}
              millesime={millesime}
              isAssujetti={isAssujetti}
              isReadOnly={isReadOnly}
            />
            <SidebarDelimiter />
          </>
        )}
      </div>
    </div>
  );
}
